define(["jquery"], function ($) {
    const selectors = ['.ue-c-article__tags', '.content-links'];

    selectors.forEach(function(selector){
        let object = $(`${selector}`);
        if  (object.length && object.children().length === 0) {
            if (object.children().length === 0){
                object.remove();
            }
        }
    });
});
